<template>
    <div class="medical-records ">
        <div class="row mb-4 food-section">
            <div class="col-12 select-meals ">
                <div class="card border-0">
                    <div class="card-body bg-white border-radius-5 p-4">
                        <div class="row no-gutters d-flex justify-content-center align-items-center Meals-area">
                            <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                <h2>Today</h2>
                                <router-link to="grocery-list" class="btn btn-blue Create-Shopping ">Create Shopping List</router-link>
                            </div>
                            <div class="col-md-12">
                                <div class="row no-gutters">
                                    <div
                                        class="col-md-12 border-bottom  mb-4 pb-3 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/food-img-1.png"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">Breakfast</h3>
                                                <p class="mb-0">Avocado with egg</p>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list">
                                            <input type="checkbox" id="breakfast">
                                            <label class="mb-0" for="breakfast"></label>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 border-bottom  mb-4 pb-3 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/food-img-2.png"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">Lunch</h3>
                                                <p class="mb-0">Wallnut Pear Salad</p>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list">
                                            <input type="checkbox" id="lunch">
                                            <label class="mb-0" for="lunch"></label>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-4 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/food-img-4.png"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">Dinner</h3>
                                                <p class="mb-0">Vegan Barbecue Strips</p>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list">
                                            <input type="checkbox" id="dinner">
                                            <label class="mb-0" for="dinner"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters d-flex justify-content-center align-items-center Meals-area">
                            <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                <h2>Tomorrow</h2>
                            </div>
                            <div class="col-md-12">
                                <div class="row no-gutters">
                                    <div
                                        class="col-md-12 border-bottom  mb-4 pb-3 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/food-img-1.png"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">Breakfast</h3>
                                                <p class="mb-0">Avocado with egg</p>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list">
                                            <input type="checkbox" id="tom-breakfast">
                                            <label class="mb-0" for="tom-breakfast"></label>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 border-bottom  mb-4 pb-3 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/food-img-2.png"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">Lunch</h3>
                                                <p class="mb-0">Wallnut Pear Salad</p>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list">
                                            <input type="checkbox" id="tom-lunch">
                                            <label class="mb-0" for="tom-lunch"></label>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-4 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/food-img-4.png"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">Dinner</h3>
                                                <p class="mb-0">Vegan Barbecue Strips</p>
                                            </div>
                                        </div>
                                        <div class="form-group m-0 p-0 form-list">
                                            <input type="checkbox" id="tom-dinner">
                                            <label class="mb-0" for="tom-dinner"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters d-flex justify-content-center align-items-center Meals-area">
                            <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                <h2>Wednesday</h2>
                            </div>
                            <div class="col-md-12">
                                <div class="row no-gutters">
                                    <div
                                        class="col-md-12 border-bottom  mb-4 pb-3 m-0 d-flex justify-content-between align-items-center">
                                        <div class="text-left d-flex align-items-center">
                                            <figure class="mb-0"><img src="../../../../static/website/images/food-img-1.png"></figure>
                                            <div class="pl-3">
                                                <h3 class="mb-0">Breakfast</h3>
                                                <p class="mb-0">Avocado with egg</p>
                                            </div>
                                            <div class="form-group m-0 p-0 form-list">
                                                <input type="checkbox" id="wed-breakfast">
                                                <label class="mb-0" for="wed-breakfast"></label>
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 border-bottom  mb-4 pb-3 m-0 d-flex justify-content-between align-items-center">
                                            <div class="text-left d-flex align-items-center">
                                                <figure class="mb-0"><img src="../../../../static/website/images/food-img-2.png"></figure>
                                                <div class="pl-3">
                                                    <h3 class="mb-0">Lunch</h3>
                                                    <p class="mb-0">Wallnut Pear Salad</p>
                                                </div>
                                            </div>
                                            <div class="form-group m-0 p-0 form-list">
                                                <input type="checkbox" id="wed-lunch">
                                                <label class="mb-0" for="wed-lunch"></label>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mb-4 m-0 d-flex justify-content-between align-items-center">
                                            <div class="text-left d-flex align-items-center">
                                                <figure class="mb-0"><img src="../../../../static/website/images/food-img-4.png"></figure>
                                                <div class="pl-3">
                                                    <h3 class="mb-0">Dinner</h3>
                                                    <p class="mb-0">Vegan Barbecue Strips</p>
                                                </div>
                                            </div>
                                            <div class="form-group m-0 p-0 form-list">
                                                <input type="checkbox" id="wed-dinner">
                                                <label class="mb-0" for="wed-dinner"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	export default {
        name: 'select-meals',

    }
</script>


// WEBPACK FOOTER //
// src/components/website/recommended_diet/select-meals.vue